export const contactsData = {
    email: 'rkdatta@merit.ac.in',
    phone: '+919811213169',
    address: 'Qutab Institutional Area, New Delhi - 110067, India',

    sheetAPI: ''
}